export default __webpack_public_path__ + "static/media/header-kids.3a6f29c5.png";